module.exports = __webpack_public_path__ + "static/media/pcrhp-logo@2x.88fde573.png";